/**
 * @param {object} props
 * @param {string} props.className
 * @returns {JSX.Element}
 */
export const ErrorIcon = ({ className }) => {
  return (
    <svg className={className} fill='currentColor' viewBox='0 0 16 16' xmlns='http://www.w3.org/2000/svg'>
      <path d='M7.55893 8.78328H8.5589V5.03971H7.55893V8.78328ZM8.05891 10.5268C8.21148 10.5268 8.33936 10.4752 8.44256 10.372C8.54576 10.2688 8.59736 10.141 8.59736 9.9884C8.59736 9.83583 8.54576 9.70795 8.44256 9.60475C8.33936 9.50155 8.21148 9.44995 8.05891 9.44995C7.90635 9.44995 7.77846 9.50155 7.67526 9.60475C7.57206 9.70795 7.52046 9.83583 7.52046 9.9884C7.52046 10.141 7.57206 10.2688 7.67526 10.372C7.77846 10.4752 7.90635 10.5268 8.05891 10.5268ZM8.05891 14.7845L1.33331 8.05891L8.05891 1.33331L14.7845 8.05891L8.05891 14.7845Z' />
    </svg>
  );
};
